import { OrderFormValue } from './index';
var OrderFormPorting = /*@__PURE__*/ (function () {
    function OrderFormPorting() {
    }
    OrderFormPorting.prototype.getIsRequested = function () {
        return this.porting_is_requested;
    };
    OrderFormPorting.prototype.setIsRequested = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.porting_is_requested = formValue;
        return this;
    };
    OrderFormPorting.prototype.getLastProvider = function () {
        return this.porting_last_provider;
    };
    OrderFormPorting.prototype.setLastProvider = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.porting_last_provider = formValue;
        return this;
    };
    OrderFormPorting.prototype.getUltimoDay = function () {
        return this.porting_ultimo_date_day;
    };
    OrderFormPorting.prototype.setUltimoDay = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_date_day = formValue;
        return this;
    };
    OrderFormPorting.prototype.getUltimoMonth = function () {
        return this.porting_ultimo_date_month;
    };
    OrderFormPorting.prototype.setUltimoMonth = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_date_month = formValue;
        return this;
    };
    OrderFormPorting.prototype.getUltimoYear = function () {
        return this.porting_ultimo_date_year;
    };
    OrderFormPorting.prototype.setUltimoYear = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(4)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_date_year = formValue;
        return this;
    };
    OrderFormPorting.prototype.getContractDay = function () {
        return this.porting_ultimo_contract_day;
    };
    OrderFormPorting.prototype.setContractDay = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_contract_day = formValue;
        return this;
    };
    OrderFormPorting.prototype.getContractMonth = function () {
        return this.porting_ultimo_contract_month;
    };
    OrderFormPorting.prototype.setContractMonth = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_contract_month = formValue;
        return this;
    };
    OrderFormPorting.prototype.getContractYear = function () {
        return this.porting_ultimo_contract_year;
    };
    OrderFormPorting.prototype.setContractYear = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(4)
            .setMand('N')
            .setType('numeric');
        this.porting_ultimo_contract_year = formValue;
        return this;
    };
    OrderFormPorting.prototype.getIsDivergent = function () {
        return this.porting_divergent_customer_data;
    };
    OrderFormPorting.prototype.setIsDivergent = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.porting_divergent_customer_data = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentName1 = function () {
        return this.porting_divergent_customer_data_name_1;
    };
    OrderFormPorting.prototype.setDivergentName1 = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string');
        this.porting_divergent_customer_data_name_1 = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentName2 = function () {
        return this.porting_divergent_customer_data_name_2;
    };
    OrderFormPorting.prototype.setDivergentName2 = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string');
        this.porting_divergent_customer_data_name_2 = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentStreet = function () {
        return this.porting_divergent_customer_data_street;
    };
    OrderFormPorting.prototype.setDivergentStreet = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.porting_divergent_customer_data_street = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentStreetNumber = function () {
        return this.porting_divergent_customer_data_houseno;
    };
    OrderFormPorting.prototype.setDivergentStreetNumber = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(8)
            .setMand('N')
            .setType('alphanumeric');
        this.porting_divergent_customer_data_houseno = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentZipCode = function () {
        return this.porting_divergent_customer_data_zip;
    };
    OrderFormPorting.prototype.setDivergentZipCode = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(5)
            .setMax(5)
            .setMand('N')
            .setType('numeric');
        this.porting_divergent_customer_data_zip = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentCity = function () {
        return this.porting_divergent_customer_data_city;
    };
    OrderFormPorting.prototype.setDivergentCity = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.porting_divergent_customer_data_city = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentNumber = function () {
        return this.porting_divergent_customer_data_no;
    };
    OrderFormPorting.prototype.setDivergentNumber = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.porting_divergent_customer_data_no = formValue;
        return this;
    };
    OrderFormPorting.prototype.getCustomerNumber = function () {
        return this.porting_customer_no;
    };
    OrderFormPorting.prototype.setCustomerNumber = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.porting_customer_no = formValue;
        return this;
    };
    OrderFormPorting.prototype.getBeginDate = function () {
        return this.porting_begin_date;
    };
    OrderFormPorting.prototype.setBeginDate = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(10)
            .setMax(10)
            .setMand('N')
            .setType('date');
        this.porting_begin_date = formValue;
        return this;
    };
    OrderFormPorting.prototype.getMissionType = function () {
        return this.porting_missiontype;
    };
    OrderFormPorting.prototype.setMissionType = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.porting_missiontype = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentBirthDay = function () {
        return this.porting_divergent_customer_data_dob_day;
    };
    OrderFormPorting.prototype.setDivergentBirthDay = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_divergent_customer_data_dob_day = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentBirthMonth = function () {
        return this.porting_divergent_customer_data_dob_month;
    };
    OrderFormPorting.prototype.setDivergentBirthMonth = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(2)
            .setMand('N')
            .setType('numeric');
        this.porting_divergent_customer_data_dob_month = formValue;
        return this;
    };
    OrderFormPorting.prototype.getDivergentBirthYear = function () {
        return this.porting_divergent_customer_data_dob_year;
    };
    OrderFormPorting.prototype.setDivergentBirthYear = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(4)
            .setMax(4)
            .setMand('N')
            .setType('numeric');
        this.porting_divergent_customer_data_dob_year = formValue;
        return this;
    };
    OrderFormPorting.prototype.getType = function () {
        return this.porting_type;
    };
    OrderFormPorting.prototype.setType = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(3)
            .setMax(20)
            .setMand('N')
            .setType('selection[Off|Vertragsende|Wunschtermin|schnellstm\u00f6glich]');
        this.porting_type = formValue;
        return this;
    };
    return OrderFormPorting;
}());
export { OrderFormPorting };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-porting.ts
// module id = null
// module chunks = 